<template>
    <div class="row py-lg-5">
        <div class="col-12 col-lg-4 col-xl-3">
            <div ref="sidebarContainer">
                <affix
                    class="sidebar-menu"
                    relative-element-selector="#educations"
                    :scroll-affix="true"
                    :offset="{ top: 130, bottom: 0 }"
                    :enabled="!isMobile && !isLoading"
                    :style="sidebarWidth"
                >
                    <education-filters
                        v-model="selectedFilters"
                        :filters-options="filters"
                    ></education-filters>
                    <div
                        class="education-overview__seo-text rte d-none d-lg-block p-2"
                        v-html="seoText"
                    ></div>
                </affix>
            </div>
        </div>

        <div id="educations" class="col-12 col-lg-8 offset-xl-1">
            <div class="row">
                <div
                    v-if="
                        typeof quickFilters.filters !== 'undefined' &&
                            quickFilters.filters.length > 0
                    "
                    class="col-12"
                >
                    <education-quick-filters
                        v-model="selectedFilters"
                        :filters-options="quickFilters"
                    ></education-quick-filters>
                </div>
                <div class="col-12">
                    <h3
                        v-if="!isLoading"
                        class="education-overview__count mb-1"
                    >
                        {{ educationCount }} Opleidingen gevonden
                    </h3>
                    <h3 v-if="hasError" class="education-overview__count mb-1">
                        Helaas, er is iets misgegaan met het ophalen van de
                        resultaten. Probeer opnieuw.
                    </h3>
                    <div v-show="isLoading" class="loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
            <template v-if="!isLoading">
                <education-direction
                    v-for="direction in filters.directions.filters"
                    :key="direction.id"
                    :direction="direction"
                    :educations="educations"
                ></education-direction>
            </template>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import EducationFilters from '@/components/education/education-filters';
import EducationQuickFilters from '@/components/education/education-quick-filters';
import EducationDirection from '@/components/education/education-direction';
import { Affix } from 'vue-affix';

export default {
    components: {
        EducationFilters,
        EducationQuickFilters,
        EducationDirection,
        Affix
    },
    props: {
        seoText: {
            type: String,
            default: ''
        },
        params: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            settings: {},
            filters: {},
            isLoading: true,
            hasError: false,
            quickFilters: {
                filters: []
            },
            educations: [],
            educationCount: 0,
            selectedFilters: {},
            isMobile: true,
            width: 'auto'
        };
    },

    computed: {
        allSelectedFilters() {
            let filters = [];
            Object.values(this.selectedFilters).forEach(
                value => (filters = filters.concat(value))
            );
            return filters;
        },

        sidebarWidth() {
            return {
                width: this.width
            };
        }
    },

    watch: {
        selectedFilters: {
            handler() {
                this.getFilteredResults();

                let path = this.settings.educationPage;
                this.allSelectedFilters.forEach(filter => {
                    const part =
                        '/' + filter.name.replace(/[^a-zA-Z0-9]+/g, '-');
                    path = path.concat(part);
                });

                path = path.toLowerCase().trim() + '/';
                this.$router.replace({ path: path }).catch(() => {});
            },
            deep: true
        }
    },
    created() {
        this.settings = window.settings;
        this.getFiltersFromUrl();
        this.getInitialResults();
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.calculateIsMobile);
            window.addEventListener('resize', this.setWidth);

            this.calculateIsMobile();
            this.setWidth();
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.calculateIsMobile);
        window.removeEventListener('resize', this.setWidth);
    },

    methods: {
        calculateIsMobile() {
            this.isMobile = window.innerWidth <= 991;
        },

        setWidth() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.width = this.$refs.sidebarContainer.clientWidth + 'px';
            }, 300);
        },

        getInitialResults() {
            this.hasError = false;
            this.isLoading = true;
            const url = '/api/EducationApi/GetFiltersEducations';
            const params = this.$route.params.pathMatch;

            if (params) {
                return false;
            }
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    if (!response.data === null) {
                        this.hasError = true;
                        return;
                    }
                    this.filters = response.data.filters;
                    this.quickFilters = response.data.filters.quickFilters;
                    this.educations = response.data.results;
                    this.educationCount = response.data.resultCount;
                    delete this.filters.quickFilters;
                })
                .catch(() => {
                    this.hasError = true;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        createQueryString() {
            let queryString = '';

            this.allSelectedFilters.forEach((filter, index) => {
                let part = '&filter=' + filter.filter;
                if (index < 1) {
                    part = '?filter=' + filter.filter;
                }
                queryString = queryString.concat(part);
            });

            return queryString;
        },

        getFiltersFromUrl() {
            const url = '/api/EducationApi/GetFiltersFromParams';
            const params = this.$route.params.pathMatch;
            let queryString = '';

            if (params === undefined) {
                return false;
            }

            params.split('/').forEach((param, index) => {
                let part = '&filters=' + param;
                if (index < 1) {
                    part = '?filters=' + param;
                }
                queryString = queryString.concat(part);
            });

            Axios({
                method: 'get',
                url: url + queryString
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }
                    this.selectedFilters = response.data;
                    return true;
                })
                .catch(() => false);

            return true;
        },

        getFilteredResults() {
            this.hasError = false;
            this.isLoading = true;
            const url = '/api/EducationApi/GetFiltersEducations';
            const queryString = this.createQueryString();
            Axios({
                method: 'get',
                url: url + queryString
            })
                .then(response => {
                    if (!response.data === null) {
                        this.hasError = true;
                        return;
                    }
                    this.filters = response.data.filters;
                    this.educations = response.data.results;
                    this.educationCount = response.data.resultCount;
                })
                .catch(() => {
                    this.hasError = true;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.vue-affix {
    @include media-breakpoint-down(md) {
        position: unset;
    }
}

.education-overview__seo-text {
    background-color: $color-gray;
}

.education-overview__count {
    font-size: 1.5rem;
    text-transform: uppercase;
}
</style>
